/*
 * Copyright (c) 2023, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react'
import PropTypes from 'prop-types'
import {Box, Text, HStack} from '@salesforce/retail-react-app/app/components/shared/ui'

/**
 * Image with text component
 *
 * @param {object} props
 */
export const PercentageTile = ({percentage, description}) => {
    return (
        <Box>
            <HStack>
                <Box border="10px solid white" borderRadius="50%">
                    <Box
                        w="8.5rem"
                        h="8.5rem"
                        m="0 auto"
                        backgroundColor="white"
                        borderRadius="50%"
                        borderWidth="8px"
                        borderStyle="solid"
                        borderColor="borderColor1"
                        color="primaryColor"
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        justifyContent="center"
                        gap="0.3rem"
                    >
                        <Text fontSize="3xl" fontWeight="bold" lineHeight="2rem">
                            {percentage}%
                        </Text>
                        <Text fontWeight="semibold">OFF</Text>
                    </Box>
                </Box>
            </HStack>

            <Text textAlign="center" my="1rem" fontSize="md">
                {description}
            </Text>
        </Box>
    )
}

PercentageTile.propTypes = {
    percentage: PropTypes.string,
    description: PropTypes.string
}

export default PercentageTile
